import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TIcecatState = {
  data: [];
  perPage: number;
  currentPage: number;
  totalPage: number;
  searchTerm: string;
  loading: boolean;
  sortBy: string;
  sortColumn: string;
  rerender1: boolean;
  totalCount: number
};

const initialIcecatState: TIcecatState = {
  data: [],
  perPage: 10,
  currentPage: 1,
  totalPage: 1,
  searchTerm: "",
  loading: false,
  sortBy: "desc",
  sortColumn: "",
  rerender1: false,
  totalCount: 0
};

export const icecatSlice = createSlice({
  name: "icecat",
  initialState: initialIcecatState,
  reducers: {
    setIcecat: (state: TIcecatState, { payload }: PayloadAction<[]>) => {
      state.data = payload;
    },
    setPerPage: (state: TIcecatState, { payload }: PayloadAction<number>) => {
      state.perPage = payload;
    },
     setTotalCount: (state: TIcecatState, { payload }: PayloadAction<number>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (
      state: TIcecatState,
      { payload }: PayloadAction<number>
    ) => {
      state.currentPage = payload;
    },
    setTotalPage: (
      state: TIcecatState,
      { payload }: PayloadAction<number>
    ) => {
      state.totalPage = payload;
    },
    setSearchTerm: (
      state: TIcecatState,
      { payload }: PayloadAction<string>
    ) => {
      state.searchTerm = payload;
    },
    setSortBy: (state: TIcecatState, { payload }: PayloadAction<string>) => {
      state.sortBy = payload;
    },
    setSortColumn: (
      state: TIcecatState,
      { payload }: PayloadAction<string>
    ) => {
      state.sortColumn = payload;
      state.sortBy = "desc";
    },
    setLoading: (state: TIcecatState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setRerender: (
      state: TIcecatState,
      { payload }: PayloadAction<boolean>
    ) => {
      state.rerender1 = payload;
    },
  },
});

export const {
  setIcecat,
  setPerPage,
  setCurrentPage,
  setSortColumn,
  setSortBy,
  setTotalPage,
  setSearchTerm,
  setLoading,
  setRerender,
  setTotalCount
} = icecatSlice.actions;
export default icecatSlice.reducer;
